/**
 * Central trace/error-reference conventions (see the observability conventions ADR in Odin.Bff).
 * Change defaults here only.
 */
export const TRACE_CONFIG = {
  /** Key in the `features` toggles (environment.featureToggles). Absent = off. */
  featureFlag: 'trace-propagation',

  /** Request header carrying the W3C trace context. */
  traceparentHeader: 'traceparent',

  /** Response header in which the backend returns its trace reference. */
  responseReferenceHeader: 'x-trace-id',

  /** W3C trace-context version and flags (01 = sampled, 00 = not sampled). */
  version: '00',
  sampledFlags: '01',
  unsampledFlags: '00',

  /** Byte lengths of the ids (hex length is double). */
  traceIdBytes: 16,
  spanIdBytes: 8,

  /** Number of leading hex chars of the trace id shown to users, upper case (ADR §8). */
  referenceLength: 8,

  /** Fraction of new traces marked sampled when no TRACE_ENV_CONFIG is provided (ADR §5). */
  defaultSampleRate: 1,

  /** Snackbar duration (ms) for the error toast. */
  toastDurationMs: 10000,
} as const;

export const TRACEPARENT_PATTERN = /^00-[0-9a-f]{32}-[0-9a-f]{16}-[0-9a-f]{2}$/;

/** Per-environment trace settings (environment.trace). */
export interface TraceEnvironmentConfig {
  /** 0..1 fraction of requests whose traceparent carries the sampled flag. The server honours it (parent-based sampling). */
  sampleRate: number;
}
